var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpto80Icon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 60,
    viewBox: "0 0 84 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 60,
    rx: 29.4545,
    fill: "#D8ECED"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7153_11552)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_7153_11552)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.0814 28.9979C30.0447 28.5578 29.2871 27.9568 28.8174 27.1839C28.3434 26.4164 28.108 25.5701 28.108 24.656C28.108 23.0861 28.6554 21.7898 29.7458 20.7684C30.8362 19.7459 32.3919 19.2324 34.4008 19.2324C36.4098 19.2324 37.9414 19.7459 39.0416 20.7684C40.1419 21.7909 40.6948 23.0861 40.6948 24.656C40.6948 25.6293 40.4408 26.4952 39.9317 27.2572C39.4281 28.0148 38.7143 28.5972 37.7947 28.9979C38.9639 29.4676 39.8485 30.1518 40.4594 31.0517C41.0659 31.956 41.3692 32.9928 41.3692 34.1719C41.3692 36.1184 40.7528 37.6982 39.5157 38.9156C38.283 40.133 36.6408 40.7395 34.5859 40.7395C32.6787 40.7395 31.0946 40.2359 29.8224 39.2287C28.3259 38.0452 27.5781 36.4118 27.5781 34.3438C27.5781 33.2041 27.8617 32.1575 28.4244 31.2039C28.9871 30.2504 29.8717 29.5169 31.0793 28.9979H31.0814Z",
    stroke: "#187C85",
    strokeWidth: 0.930569,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9249 24.9492C31.9249 25.7516 32.1494 26.3822 32.5993 26.8322C33.0536 27.2822 33.6558 27.5066 34.4035 27.5066C35.1513 27.5066 35.7731 27.2767 36.2274 26.8223C36.6818 26.368 36.9117 25.7363 36.9117 24.9349C36.9117 24.1773 36.6872 23.5708 36.2373 23.1154C35.783 22.6611 35.1863 22.4312 34.4473 22.4312C33.7083 22.4312 33.0635 22.6611 32.6081 23.1209C32.1537 23.5807 31.9238 24.1916 31.9238 24.9503L31.9249 24.9492Z",
    stroke: "#187C85",
    strokeWidth: 0.930569,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5421 33.9575C31.5421 35.0774 31.8257 35.9478 32.3928 36.574C32.9599 37.2002 33.6638 37.5133 34.5101 37.5133C35.3564 37.5133 36.0264 37.2101 36.5694 36.609C37.1124 36.008 37.3806 35.1365 37.3806 34.0023C37.3806 33.0094 37.1069 32.2124 36.554 31.6113C36.0012 31.0103 35.3027 30.707 34.4564 30.707C33.4733 30.707 32.7453 31.0497 32.2603 31.7339C31.7808 32.4182 31.541 33.1572 31.541 33.9585L31.5421 33.9575Z",
    stroke: "#187C85",
    strokeWidth: 0.930569,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_7153_11552)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.553 19.3975C51.5586 19.3975 53.126 20.1164 54.2594 21.5531C55.6044 23.25 56.2801 26.0706 56.2801 30.0051C56.2801 33.9397 55.6001 36.7603 54.2454 38.4766C53.1217 39.8939 51.5597 40.6031 49.5541 40.6031C47.5485 40.6031 45.9142 39.827 44.6794 38.2747C43.4456 36.7225 42.8281 33.9494 42.8281 29.9674C42.8281 25.9853 43.5071 23.2403 44.8618 21.524C45.9855 20.1067 47.5474 19.3975 49.553 19.3975Z",
    stroke: "#187C85",
    strokeWidth: 0.917525,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5528 22.6949C49.08 22.6949 48.6558 22.8493 48.2898 23.158C47.9185 23.4613 47.6292 24.0118 47.4263 24.8074C47.1564 25.8339 47.0215 27.5697 47.0215 30.0049C47.0215 32.4401 47.1424 34.1176 47.3831 35.0286C47.6238 35.9397 47.9282 36.5474 48.2941 36.8507C48.6601 37.154 49.08 37.3041 49.5528 37.3041C50.0256 37.3041 50.4498 37.1497 50.8211 36.841C51.187 36.5377 51.4763 35.9872 51.6793 35.1916C51.9491 34.1748 52.0841 32.4434 52.0841 30.0038C52.0841 27.5643 51.9632 25.8955 51.7225 24.9844C51.4817 24.0734 51.1773 23.4613 50.8114 23.1569C50.4455 22.8482 50.0256 22.6938 49.5528 22.6938V22.6949Z",
    stroke: "#187C85",
    strokeWidth: 0.917525,
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7153_11552"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.5,
    y: 17.644,
    width: 41,
    height: 24.7123,
    rx: 12.3562,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_7153_11552"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.7216,
    height: 22.4377,
    fill: "white",
    transform: "translate(27.1152 18.7671)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_7153_11552"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.3706,
    height: 22.1232,
    fill: "white",
    transform: "translate(42.3691 18.9385)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpto80Icon);
export default __webpack_public_path__ + "static/media/upto80-icon.1c4346fe09e74caa76680cbe4f0afe5c.svg";
export { ForwardRef as ReactComponent };